module.exports={
	"Form": "ProjectTypeViewManifest",
	"Scope": "ProjectType-View",
	"Descriptors":
	{
		"ProjectTypeDetails.IDProjectType":
		{
			"Name": "ID",
			"Hash": "ProjectTypeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.GUIDProjectType":
		{
			"Name": "GUID",
			"Hash": "ProjectTypeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectTypeView-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "ProjectTypeView-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "ProjectTypeView-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails.Ordinal":
		{
			"Name": "Order",
			"Hash": "ProjectTypeView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 2,
				"Section": "ProjectTypeIdentity",
				"Group": "ProjectTypeIdentity"
			}
		},
		"ProjectTypeDetails._DisplaySettings.AvailableStatusList":
		{
			"Name": "Available Statuses",
			"Hash": "ProjectTypeView-AvailableStatusList",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.StatusesRequiringChangeOrder":
		{
			"Name": "Statuses Requiring Change Order",
			"Hash": "ProjectTypeView-StatusesRequiringChangeOrder",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.DefaultDatesText":
		{
			"Name": "Default Project Dates",
			"Hash": "ProjectTypeView-DefaultDates",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 6,
				"Section": "ProjectTypeSettings",
				"Group": "ProjectTypeSettings"
			}
		},
		"ProjectTypeDetails._DisplaySettings.PrototypeProjectName":
		{
			"Name": "Prototype Project",
			"Hash": "ProjectTypeView-PrototypeProjectName",
			"DataType": "String",
			"Description": "The canonical prototype project an admin configures for this project type; cloned onto real projects of this type.",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectTypePrototype",
				"Group": "ProjectTypePrototype"
			}
		},
		"ProjectTypeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ProjectTypeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ProjectTypeView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ProjectTypeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		},
		"ProjectTypeDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ProjectTypeView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ProjectTypeAudit",
				"Group": "ProjectTypeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectTypeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectTypeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Settings",
			"Hash": "ProjectTypeSettings",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Settings",
					"Hash": "ProjectTypeSettings",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Prototype Project",
			"Hash": "ProjectTypePrototype",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Prototype Project",
					"Hash": "ProjectTypePrototype",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ProjectTypeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ProjectTypeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
